import { gql } from '@apollo/client';

const SUBMIT_RETURN_CANCEL = gql`
  query submitReturnCancel($cancelDetail: OrderCancelDetails) {
    orderCancel(cancelDetail: $cancelDetail) {
      status
    }
  }
`;

export default SUBMIT_RETURN_CANCEL;
